<template lang="pug">
transition(
  name="photo-gallery"
)
  .photo-gallery-mask(
    @click="onCloseGallery()"
  )
    .photo-gallery__close
      button.photo-gallery-button-close(
        @click="onCloseGallery()"
      )
        img(src="@/assets/images/icons/close-button.svg")
    .photo-gallery-wrapper
      .photo-gallery(
        @click="onClickGallery($event)"
      )
        .photo-gallery__body(
          v-if="photos.length > 0"
        )
          .photo-gallery__buttons
            .button__arrow.button__left(@click="clickLeftPhoto()")
            .button__arrow.button__right(@click="clickRightPhoto()")
          .photo-gallery__main-image
            img(:src="photos[activePhoto].file")
          .photo-gallery__rest-images
            .rest-images
              .photo(
                v-for="(img, index) in photos"
                :class="{ 'active-photo': index === activePhoto }"
                @click="changeActivePhoto(index)"
              )
                img(:src="img.preview_376x340")
</template>
<script>
export default {
  name: "PhotoGallery",
  props: {
    photos: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    activePhoto: 0
  }),
  methods: {
    onCloseGallery() {
      this.$emit("onHidePhotoGallery");
      this.activePhoto = 0;
    },
    onClickGallery(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    changeActivePhoto(index) {
      this.activePhoto = index;
      const image = new Image();
      image.onload = () => {
        // image on loading
      };
      image.src = this.photos[index].file;
    },
    clickLeftPhoto() {
      if (this.activePhoto === 0) {
        this.activePhoto = this.photos.length - 1;
        return;
      }
      this.activePhoto -= 1;
    },
    clickRightPhoto() {
      if (this.activePhoto < this.photos.length - 1) {
        this.activePhoto += 1;
        return;
      }
      this.activePhoto = 0;
    }
  }
};
</script>
